module.exports = __webpack_public_path__ + "img/2.5ed4b3ff.png";